export default "__VITE_ASSET__459412bf__"